import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { getNotificationAlertsUnreadCount } from '../../stores/notification-alerts/getters';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: 'var(--color-colorsForValuesRed)',
    color: '#fff',
    minWidth: 22,
    height: 22,
    display: 'inline-flex',
    borderRadius: '12px',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    padding: 4,
    fontWeight: 500,
  },
}));

const AnnouncementUnreadCount = ({ className = '' }) => {
  const classes = useStyles();
  const unreadCount = useSelector(getNotificationAlertsUnreadCount) || 0;
  const formattedCount = unreadCount > 99 ? '99+' : `${unreadCount}`;

  if (!unreadCount) {
    return <></>;
  }

  return (
    <span className={`AnnouncementUnreadCount ${classes.root} ${className}`}>
      {formattedCount}
    </span>
  );
};

export default AnnouncementUnreadCount;
